<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.printer_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.printer_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.printer_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.printer_form.label_serial_number')"
                outlined
                v-model="input.serial_number"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.printer_form.label_mac_address')"
                outlined
                v-model="input.mac_address"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <!-- <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.printer_form.label_area')"
                outlined
                v-model="input.area"
                type="number"
              ></v-text-field>
            </div> -->

            <div class="select-box col-md-6">
              <v-select
                :items="locations"
                item-text="description"
                v-model="input.area_id"
                item-value="id"
                :label="$t('lang.admin.printer_form.label_area')"
                outlined
              ></v-select>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.printer_form.label_ip_address')"
                outlined
                v-model="input.ip_address"
              ></v-text-field>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.printer_form.label_service_port')"
                outlined
                v-model="input.service_port"
                type="number"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn
                text
                rounded
                @click="$router.push({ name: 'PrintersList' })"
                >{{ $t("lang.location_form.btn_cancel") }}</v-btn
              >
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.admin.printer_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let Input = () => {
  return {
    serial_number: null,
    mac_address: null,
    area_id: null,
    ip_address: null,
    service_port: null
  };
};

export default {
  name: "AddPrinterForm",
  data() {
    return {
      input: new Input(),
      errors: [],
      locations: [],
      success: {
        show: false,
        message: this.$t("lang.admin.printer_form.success_add")
      },
      errorLabels: {
        serialNumber: this.$t("lang.admin.printer_form.errors.serial_number"),
        macAddress: this.$t("lang.admin.printer_form.errors.mac_address"),
        areaError: this.$t("lang.admin.printer_form.errors.location"),
        ipAddress: this.$t("lang.admin.printer_form.errors.ip_address"),
        servicePort: this.$t("lang.admin.printer_form.errors.service_port"),
        location: this.$t("lang.admin.printer_form.errors.location"),
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.locations = await this.$api.area.list();
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        try {
          let response = await this.$api.printer.add(input);
          if (response) {
            this.success.show = true;
          }
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
        } finally {
          this.input = new Input();
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.serial_number) {
        error = true;
        this.errors.push(this.errorLabels.serialNumber);
      }

      if (!this.input.mac_address) {
        error = true;
        this.errors.push(this.errorLabels.macAddress);
      }

      if (!this.input.area_id) {
        error = true;
        this.errors.push(this.errorLabels.areaError);
      }
      if (!this.input.ip_address) {
        error = true;
        this.errors.push(this.errorLabels.ipAddress);
      }
      if (!this.input.service_port) {
        error = true;
        this.errors.push(this.errorLabels.servicePort);
      }

      if (error) {
        return false;
      }

      return true;
    }
  }
};
</script>
